import axios from 'axios'
import { pushToDataLayer } from 'utils/eventPushes'
import key from 'utils/localStorageKeys'
import { getSharedProject, shareTokenFor } from './ShareLinkApi'
import { axiosInstance } from './axiosInstance'
import { END_POINT_PDF, END_POINT_PRODUCT } from './index'

export function getProjects(page, search, size = 10) {
  const shared = window.location.pathname.includes('shared')

  const serachQuery = search ? `search=${search}` : ''

  const url =
    page != null
      ? `${END_POINT_PRODUCT}/api/takeoffs${shared ? '/shared' : ''}?page=${page}&size=${size}&${serachQuery}`
      : `${END_POINT_PRODUCT}/api/takeoffs${shared ? '/shared' : ''}?size=${size}&${serachQuery}`

  return axiosInstance.request({
    method: 'get',
    url: url,
    // headers: {
    //     Authorization: 'Bearer ' + userToken
    // }
  })
}

export function getProjectById(id) {
  const shareToken = shareTokenFor(id)
  if (shareToken) return getSharedProject(shareToken)
  return axiosInstance.request({
    method: 'get',
    url: `${END_POINT_PRODUCT}/api/takeoffs/${id}`,
  })
}

export function inviteUserToProject(data) {
  return axiosInstance.request({
    method: 'post',
    url: `${END_POINT_PRODUCT}/api/takeoff-access`,
    data,
  })
}

import { createFingerprint } from 'utils/fingerprint'

export async function getSubscription() {
  const fingerprint = await createFingerprint()
  return axiosInstance.request({
    method: 'get',
    url: `${END_POINT_PRODUCT}/api/subscription`,
    headers: {
      'X-Device-Fingerprint': fingerprint,
    },
  })
}

export async function updateUserAccess(data) {
  try {
    const response = await axiosInstance.request({
      method: 'put',
      url: `${END_POINT_PRODUCT}/api/takeoff-access`,
      data,
    })
    // Handle successful response here
    return response
  } catch (error) {
    if (error.response && error.response.status === 400) {
      // Handle 400 error specifically
      console.error('Bad request error: ', error.response.data)
      // Optionally, update UI or state to reflect the error
    } else {
      // Handle other kinds of errors
      console.error('An error occurred: ', error)
    }
    // You can return a default value or error indicator here
    return null
  }
}

export function deleteAccess(projectId, takeoffAccessId) {
  return axiosInstance.request({
    method: 'delete',
    url: `${END_POINT_PRODUCT}/api/takeoff-access/${projectId}/${takeoffAccessId}`,
  })
}

export function getAllowedUsers(id) {
  return axiosInstance.request({
    method: 'get',
    url: `${END_POINT_PRODUCT}/api/takeoff-access/${id}`,
  })
}

export function getMaterialsGroups() {
  return axiosInstance.request({
    method: 'get',
    url: `${END_POINT_PRODUCT}/api/takeoff-materials/groups`,
  })
}

export function postMaterialsGroups(data) {
  return axiosInstance.request({
    method: 'post',
    url: `${END_POINT_PRODUCT}/api/takeoff-materials/groups`,
    data,
  })
}

export function updateProjectMaterialConfig(projectId, materialId, assemblyConfig) {
  return axiosInstance.request({
    method: 'put',
    url: `${END_POINT_PRODUCT}/api/project/${projectId}/takeoff-materials/${materialId}/assembly-config`,
    data: assemblyConfig,
  })
}
export function downloadPdfPage(drawingPageId, projectId) {
  return axiosInstance.request({
    method: 'get',
    url: `${END_POINT_PDF}/api/download-page/${projectId}/${drawingPageId}`,
    responseType: 'blob',
  })
}

// drawingSetId scopes the export to a single drawing set (addendum/revision);
// null/undefined returns every page across all sets.
/**
 * @param {string} projectId
 * @param {boolean} [markedUpOnly]
 * @param {string | null} [drawingSetId]
 */
export function downloadPdfProject(projectId, markedUpOnly = false, drawingSetId = null) {
  return axiosInstance.request({
    method: 'get',
    url: `${END_POINT_PDF}/api/download-pages/${projectId}`,
    params: {
      ...(markedUpOnly ? { marked_up_only: true } : {}),
      ...(drawingSetId ? { drawing_set_id: drawingSetId } : {}),
    },
    responseType: 'blob',
    validateStatus: (status) => status === 200 || status === 204,
  })
}

/**
 * Creates a customized drawing PDF. page_ids are emitted in the supplied order.
 * Omit shape_types/shape_ids to include every shape in an enabled layer.
 */
export function exportPdfProject(projectId, options) {
  return axiosInstance.request({
    method: 'post',
    url: `${END_POINT_PDF}/api/export-pages/${projectId}`,
    data: options,
    responseType: 'blob',
    validateStatus: (status) => status === 200 || status === 204,
  })
}

export function editMaterialsGroup(data) {
  return axiosInstance.request({
    method: 'put',
    url: `${END_POINT_PRODUCT}/api/takeoff-materials/groups`,
    data,
  })
}

export function getProjectMaterials(projectId) {
  if (key.TOKEN) {
    return axiosInstance.request({
      method: 'get',
      url: `${END_POINT_PRODUCT}/api/project/${projectId}/takeoff-materials`,
    })
  }
  return axios.request({
    method: 'get',
    url: `${END_POINT_PRODUCT}/api/project/${projectId}/takeoff-materials`,
  })
}

// export function getSampleProjectMaterials(projectId) {
//   return axiosInstance.request({
//     method: 'get',
//     url: `${END_POINT_PRODUCT}/api/project/${projectId}/takeoff-materials`
//   })
// }

export function postProjectMaterial(projectId, materialIds) {
  return axiosInstance.request({
    method: 'post',
    url: `${END_POINT_PRODUCT}/api/project/${projectId}/takeoff-materials`,
    data: materialIds,
  })
}

export function deleteProjectMaterials(projectId, materialId) {
  return axiosInstance.request({
    method: 'delete',
    url: `${END_POINT_PRODUCT}/api/project/${projectId}/takeoff-materials/${materialId}`,
  })
}
export function toggleProjectMeasureSystem(projectId) {
  return axiosInstance.request({
    method: 'put',
    url: `${END_POINT_PRODUCT}/api/takeoffs/toggle-unit/${projectId}`,
  })
}

export function getUserMaterials() {
  return axiosInstance.request({
    method: 'get',
    url: `${END_POINT_PRODUCT}/api/takeoff-materials/user`,
  })
}

export function postMaterial(data) {
  return axiosInstance.request({
    method: 'post',
    url: `${END_POINT_PRODUCT}/api/takeoff-materials`,
    data,
  })
}

export function editMaterial(data) {
  console.log('editMaterial data:', data)
  return axiosInstance.request({
    method: 'put',
    url: `${END_POINT_PRODUCT}/api/takeoff-materials`,
    data,
  })
}

export function deleteMaterial(id) {
  return axiosInstance.request({
    method: 'delete',
    url: `${END_POINT_PRODUCT}/api/takeoff-materials/${id}`,
  })
}

export function getArchivedProjects(search, page, size = 10) {
  const serachQuery = search ? `search=${search}` : ''

  const url =
    page != null
      ? `${END_POINT_PRODUCT}/api/archived/takeoffs?page=${page}&size=${size}&${serachQuery}`
      : `${END_POINT_PRODUCT}/api/archived/takeoffs?size=${size}&${serachQuery}`

  return axiosInstance.request({
    method: 'get',
    url: url,
    // headers: {
    //     Authorization: 'Bearer ' + userToken
    // }
  })
}

export function deleteArchivedProject(projectId) {
  return axiosInstance.request({
    method: 'delete',
    url: `${END_POINT_PRODUCT}/api/archived/takeoffs/${projectId}`,
  })
}

// Recover Archived Project
export function restoreArchivedProject(projectId) {
  return axiosInstance.request({
    method: 'put',
    url: `${END_POINT_PRODUCT}/api/takeoffs/recover/${projectId}`,
  })
}

export function postProject(data) {
  return axiosInstance.request({
    method: 'post',
    url: `${END_POINT_PRODUCT}/api/takeoffs`,
    // headers: {
    //     Authorization: 'Bearer ' + userToken
    // },
    data,
  })
}

export function putProject(data) {
  return axiosInstance.request({
    method: 'put',
    url: `${END_POINT_PRODUCT}/api/takeoffs`,
    // headers: {
    //     Authorization: 'Bearer ' + userToken
    // },
    data,
  })
}

// With a revision, the server refuses (409, returning its newer page) to overwrite a page saved since that revision.
export function putDrawingPage(data, revision) {
  return axiosInstance.request({
    method: 'put',
    url: `${END_POINT_PRODUCT}/api/drawing-page`,
    ...(revision === undefined ? {} : { headers: { 'If-Match': `"${revision}"` }, skipGlobalError: true }),
    data,
  })
}

export function getDrawingPage(projectId, id) {
  return axiosInstance.request({
    method: 'get',
    url: `${END_POINT_PRODUCT}/api/drawing-page/${projectId}/${id}`,
  })
}

export function processDrawingPage(pageId) {
  return axiosInstance.request({
    method: 'get',
    url: `${END_POINT_PRODUCT}/api/drawing-page/process/${pageId}`,
    // headers: {
    //
    // },
  })
}

export function deleteDrawingPage(id, projectId) {
  return axiosInstance.request({
    method: 'delete',
    url: `${END_POINT_PRODUCT}/api/drawing-page/${projectId}/${id}`,
    // headers: {
    //     Authorization: 'Bearer ' + userToken
    // }
  })
}

export function postDrawingPage(data) {
  return axiosInstance.request({
    method: 'post',
    url: `${END_POINT_PRODUCT}/api/drawing-page`,
    // headers: {
    //     Authorization: 'Bearer ' + userToken
    // },
    data,
  })
}

// Saved without rebuilding the project's external references, which a copy doesn't change.
export function postDuplicateDrawingPage(data) {
  return axiosInstance.request({
    method: 'post',
    url: `${END_POINT_PRODUCT}/api/drawing-page/duplicate`,
    data,
  })
}

export function deleteProject(id) {
  return axiosInstance.request({
    method: 'delete',
    url: `${END_POINT_PRODUCT}/api/${id}`,
    // headers: {
    //     Authorization: 'Bearer ' + userToken
    // },
  })
}

export function getAvailableListProducts(token, query) {
  const config = {
    // headers: {
    //     Authorization: 'Bearer ' + token
    // },
    params: query,
  }

  return axios.get(`${END_POINT_PRODUCT}/api/search/autosuggest`, config).then(({ data }) => data)
}

// Remove assemblies form project
export const removeMaterialAssemblyFromProject = (projectId, assemblyId) => {
  return axiosInstance.request({
    method: 'delete',
    url: `${END_POINT_PRODUCT}/api/material-assembly/${projectId}/${assemblyId}`,
  })
}

/**
 * Get takeoffs by opportunity ID
 * GET /api/takeoffs/opportunity/{opportunityId}
 */
export function getTakeoffsByOpportunityId(opportunityId, params = {}) {
  const requestParams = {
    page: params.page || 0,
    size: params.size || 16,
  }

  if (params.sort) {
    requestParams.sort = params.sort
  }

  return axiosInstance.request({
    method: 'get',
    url: `${END_POINT_PRODUCT}/api/takeoffs/opportunity/${opportunityId}`,
    params: requestParams,
  })
}

/**
 * Assign a takeoff to an opportunity
 * PUT /api/takeoffs/{takeoffId}/opportunity
 * @param {string} takeoffId
 * @param {string} opportunityId
 * @param {boolean} includeProposals - If true, also assigns all proposals linked to this takeoff
 */
export async function assignTakeoffToOpportunity(takeoffId, opportunityId, includeProposals = true) {
  const params = includeProposals ? '?includeProposals=true' : ''
  const response = await axiosInstance.request({
    method: 'put',
    url: `${END_POINT_PRODUCT}/api/takeoffs/${takeoffId}/opportunity${params}`,
    data: opportunityId,
    headers: {
      'Content-Type': 'text/plain',
    },
  })

  pushToDataLayer({
    event: 'takeoff_added_to_opportunity',
    takeoff_id: takeoffId,
    opportunity_id: opportunityId,
    include_proposals: includeProposals,
    timestamp: new Date().toISOString(),
  })

  return response
}
